import { useMemo, useState, useEffect } from 'react';

// Generic hook that applies a filter predicate before paginating
export function useFilteredPagination(items = [], pageSize = 50, predicate = () => true) {
  const filtered = useMemo(() => (predicate ? items.filter(predicate) : items), [items, predicate]);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  useEffect(() => { setCurrentPage(1); }, [filtered.length]);
  const start = (currentPage - 1) * pageSize;
  const pageItems = filtered.slice(start, start + pageSize);
  const goToPage = p => setCurrentPage(Math.min(Math.max(1, p), totalPages));
  const next = () => goToPage(currentPage + 1);
  const prev = () => goToPage(currentPage - 1);
  return { filtered, currentPage, totalPages, pageItems, next, prev, setCurrentPage: goToPage };
}
